import type { LiteFormat } from "../../lib/format";
import type { ReportMetrics } from "../../../social-reports/metrics/types";

/** Montant d'un rapport. Les comptes sont en dollars dans l'immense majorité des cas :
 *  on garde alors le format Lite (« +1 234 $ ») ; une autre devise passe par Intl. */
export function reportMoney(fmt: LiteFormat, currency: string) {
  if (currency === "USD") return (v: number, opts: { sign?: boolean } = {}) => fmt.money(v, opts);
  const nf = new Intl.NumberFormat(fmt.locale, { style: "currency", currency, maximumFractionDigits: 0 });
  return (v: number, opts: { sign?: boolean } = {}) => `${v > 0 && (opts.sign ?? true) ? "+" : ""}${nf.format(v)}`;
}

/** ROI signé en pourcentage (« +12 % »), ou tiret sans dépense. */
export function roiText(roi: number | null, fmt: LiteFormat): string {
  if (roi === null) return "-";
  return `${roi >= 0 ? "+" : "−"}${fmt.pct(Math.abs(roi) / 100)}`;
}

/** Un rapport a-t-il une partie prop firm à montrer ? Snapshot v1 = non. */
export function hasPropFirmPart(m: ReportMetrics): boolean {
  return m.schemaVersion === 2 && (!!m.propFirmFinance || !!m.payoutsSummary || !!m.lifecycle || !!m.challengeAdvancement);
}
